module.exports = __webpack_public_path__ + "static/img/1053_small.5967e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1053_small.png
// module id = SxPK
// module chunks = 1